<template>
    <section :key="`preorder-${station ? station.id : 0}`" class="preorder">
        <BlocksStationsPreorderStationSelection :stations="sortedStations" @change="selectStation" />
        <transition name="fade">
            <div v-if="stationLoaded" class="station-container info">
                <BlocksStationsHeaderInfo :station="station" />
            </div>
        </transition>
        <transition name="fade">
            <div v-show="stationLoaded" class="station-container padded">
                <BlocksStationsPreorderSelection
                    v-if="stationLoaded"
                    :key="`selection-${station ? station.id : 0}`"
                    :station="station"
                />
            </div>
        </transition>
        <portal to="preorder-confirm-nav">
            <div class="ds-modal-content size-small confirm-nav">
                <div class="head">
                    <button class="close" :aria-label="$t('confirmNav.close')" @click="closeModal">
                        <DSIcon code="default-line/close" />
                    </button>
                </div>
                <div class="content">
                    <h2 class="h4">{{ $t('confirmNav.title') }}</h2>
                    <p>{{ $t('confirmNav.text') }}</p>
                </div>
                <div class="foot">
                    <button class="ds-btn ds-btn--secondary" @click="closeModal">
                        {{ $t('confirmNav.close') }}
                    </button>
                    <button class="ds-btn ds-btn--primary" @click="navigate(selection)">
                        {{ $t('confirmNav.ok') }}
                    </button>
                </div>
            </div>
        </portal>
    </section>
</template>
<script setup>
import { ref, computed, useHead, useRoute, useI18n, storeToRefs } from '#imports';
import { usePageStore } from '~dsc/stores/cms/page';
import { sortBy } from 'lodash-es';

const route = useRoute();
const selection = ref({});
const { station } = storeToRefs(usePageStore());

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({
    stations: {
        type: Array,
        required: false,
        default: () => [],
    },
});

useHead({
    link: { rel: 'canonical', href: `<set host here>${route.path}` },
});

const stationLoaded = computed(() => Object.keys(station).length > 0);
const sortedStations = computed(() => props.stations.length ? sortBy(props.stations, 'title') : []);

/*
function selectStation(selection) {
    if (this.station.id === selection.id) return false;

    if (this.cart.length > 0) {
        this.selection = selection;
        this.openModal('preorder-confirm-nav');
    } else {
        this.navigate(selection);
    }
}
*/

/*
function navigate(selection) {
    const station = this.stations.find(station => station.id === selection.id);
    let stationQuery = '';

    if (station) {
        stationQuery = `?station=${station.links[0]?.to.split('/').slice(-1)}`;
    }

    if (this.$route.query.station !== stationQuery) {
        this.resetCart();
        this.closeModal();
        this.$router.push(`${this.$route.path}${stationQuery}`);
    }
}
*/

useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            confirmNav: {
                title: 'Oletko varma että haluat vaihtaa asemaa?',
                text: 'Vaihtamalla asemaa valitsemasi tuotteet poistuvat listalta.',
                close: 'Peruuta',
                ok: 'Vaihda asemaa',
            },
        },
        'en-EU': {
            confirmNav: {
                title: 'Are you sure you want to change station?',
                text: 'By changing station the products in cart will be reset.',
                close: 'Cancel',
                ok: 'Change station',
            },
        },
    },
});
</script>
<style scoped>
.station-container {
  max-width: var(--page-max-width);
  margin: 0 auto;
}
.station-container.info {
  margin-top: -4rem;
}
.station-container.padded {
  padding-inline: 1.5rem;
}

.ds-modal-content.confirm-nav {
  border-radius: 0;
}
.ds-modal-content.confirm-nav > * {
  padding-inline: 1.5rem;
}
.ds-modal-content.confirm-nav .head {
  padding: 1.5rem;
}
.ds-modal-content.confirm-nav .head button {
  grid-column-start: 2;
  color: var(--color-base-grey-800);
}
.ds-modal-content.confirm-nav .content {
  padding: 1.5rem 4rem 3rem;
  text-align: center;
}
.ds-modal-content.confirm-nav .foot {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  border-top: 1px solid var(--color-base-grey-200);
  margin-bottom: -1rem;
  padding: 1rem 1.5rem 1.5rem;
}
.ds-modal-content.confirm-nav .foot button {
  width: auto;
  display: inline-flex;
  margin-bottom: 1rem;
}
.ds-modal-content.confirm-nav .foot button:not(:last-child) {
  margin-right: 1.5rem;
}

.fade-enter-active {
  transition: 1s ease;
}

.fade-enter-from {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}
</style>
